import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = [
    "departureAirport",
    "selectedDepartureAirport",
    "arrivalAirport",
    "selectedArrivalAirport"
  ]

  static values = {
    calculatorUrl: String,
    departurePlaceholder: String,
    arrivalPlaceholder: String,
    fixDataMessage: String
  }

  // Validate and submit form with airport parameters
  submit(event) {
    event.preventDefault()

    if (this.validateInputs()) {
      return
    }

    this.pushAnalyticsEvent('CTA-click-enter-funnel')

    const depApt = this.hasSelectedDepartureAirportTarget ? this.selectedDepartureAirportTarget.value : ""
    const arrApt = this.hasSelectedArrivalAirportTarget ? this.selectedArrivalAirportTarget.value : ""

    const url = this.buildUrlWithAirports(depApt, arrApt)
    window.location.href = url
  }

  // Submit without airports (direct to calculator)
  submitDirect(event) {
    event.preventDefault()
    this.pushAnalyticsEvent('CTA-click-enter-funnel')
    window.location.href = this.calculatorUrlValue
  }

  // Clear validation error on click
  clearValidation(event) {
    const input = event.currentTarget
    input.classList.remove('invalid')

    if (input.classList.contains('news-article-cta__input')) {
      input.style.removeProperty('border')
    } else {
      input.style.border = '2px solid white'
    }

    if (input.name.includes("departure")) {
      input.placeholder = this.departurePlaceholderValue
    } else {
      input.placeholder = this.arrivalPlaceholderValue
    }
  }

  // Private methods

  validateInputs() {
    let invalid = false

    if (!this.hasSelectedDepartureAirportTarget || this.selectedDepartureAirportTarget.value === "") {
      this.markInvalid(this.departureAirportTarget)
      invalid = true
    }

    if (!this.hasSelectedArrivalAirportTarget || this.selectedArrivalAirportTarget.value === "") {
      this.markInvalid(this.arrivalAirportTarget)
      invalid = true
    }

    return invalid
  }

  markInvalid(input) {
    input.classList.add('invalid')

    if (input.classList.contains('news-article-cta__input')) {
      input.style.removeProperty('border')
    } else {
      input.style.border = '2px solid #ED7D31'
    }

    input.placeholder = this.fixDataMessageValue
  }

  buildUrlWithAirports(depApt, arrApt) {
    const params = []

    if (depApt !== "" && depApt !== undefined) {
      params.push(`dep_apt=${depApt}`)
    }

    if (arrApt !== "" && arrApt !== undefined) {
      params.push(`arr_apt=${arrApt}`)
    }

    if (params.length > 0) {
      return `${this.calculatorUrlValue}?${params.join('&')}`
    }

    return this.calculatorUrlValue
  }
}

